<script setup lang="ts">
import { computed } from "vue";
import { useSnackDialogStore } from "@/stores/useSnackDialogStore.ts";
import BaseDialog from "@/components/shared/dialogs/BaseDialog.vue";
import BaseDialogActions from "@/components/shared/dialogs/BaseDialogActions.vue";

const snackDialog = useSnackDialogStore();

function onDialogClose(val: boolean) {
  if (!val) {
    snackDialog.open = false;
    if (!snackDialog.loading) {
      snackDialog.confirm();
    }
  }
}

const meta = computed(() => {
  switch (snackDialog.type) {
    case "error":
      return {
        color: "rgb(var(--v-theme-error))",
        icon: "mdi-alert-circle",
        buttonTone: "danger" as const,
      };
    case "info":
      return {
        color: "rgb(var(--v-theme-secondary))",
        icon: "mdi-information",
        buttonTone: "brand" as const,
      };
    case "sad":
      return {
        color: "rgb(var(--v-theme-pastelBlue))",
        icon: "mdi-emoticon-sad-outline",
        buttonTone: "brand" as const,
      };
    default:
      return {
        color: "rgb(var(--v-theme-secondary))",
        icon: "mdi-check-circle",
        buttonTone: "brand" as const,
      };
  }
});
</script>

<template>
  <BaseDialog
    :model-value="snackDialog.open"
    :icon="meta.icon"
    :icon-background-color="meta.color"
    max-width="360"
    :fullscreen-on-mobile="false"
    @update:model-value="onDialogClose"
  >
    <template #title>
      <div class="tw:!pt-2">{{ snackDialog.title }}</div>
    </template>
    <template #subtitle> {{ snackDialog.text }}</template>
    <template #actions>
      <BaseDialogActions
        :primary="{
          text: snackDialog.confirmText,
          loading: snackDialog.loading,
          action: snackDialog.confirm,
          tone: meta.buttonTone,
        }"
      />
    </template>
  </BaseDialog>
</template>
